







































































































































































































































































































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import { Component, Emit, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";


@Component({
  components: {
    Navbar
  }
})
export default class Swift2021 extends Vue {
  @Emit()
  openModalDetalle(
    auto: string,
    titulo: string,
    interes: string,
    version: string
  ) {
    return {
      auto: auto,
      titulo: titulo,
      interes: interes,
      version: version,
    };
  }

  expand: boolean = true;
  toggleExpand() {
    this.expand = !this.expand;
  }
}
